export default __webpack_public_path__ + "static/media/x_icon.8d262fc4.svg";